<template>
  <Appointment
    v-bind="$props"
    @remove="$emit('remove')"
  />
</template>

<script>
import Appointment from './Appointment'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Appointment
  },
  mixins: [cardMixin],
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  emits: ['remove']
}
</script>
